export default "__VITE_ASSET__DtIFcO0C__"